/** Lightweight form validation helpers (no external schema dependency). */

export function parsePositiveAmount(
	value: string,
): { ok: true; amount: number } | { ok: false; error: string } {
	const amount = Number.parseFloat(value);
	if (Number.isNaN(amount) || amount <= 0) {
		return { ok: false, error: "Enter an amount greater than zero." };
	}
	return { ok: true, amount };
}

export function validateAmountWithinBalance(
	amount: number,
	balance: number,
	symbol = "tokens",
): string | undefined {
	if (amount > balance) {
		return `Exceeds available balance (${balance.toLocaleString(undefined, { maximumFractionDigits: 4 })} ${symbol}).`;
	}
	return undefined;
}

export function validateAmountWithinMax(
	amount: number,
	max: number,
	symbol = "USDM",
): string | undefined {
	if (amount > max) {
		return `Enter an amount up to ${max.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${symbol}.`;
	}
	return undefined;
}

export function validatePrincipal(value: string): string | undefined {
	const trimmed = value.trim();
	if (!trimmed) return "Recipient principal is required.";
	if (trimmed.length < 10) return "Enter a valid IC principal ID.";
	return undefined;
}

export function validateRecipientForToken(
	token: string,
	value: string,
): string | undefined {
	const trimmed = value.trim();
	if (!trimmed) return "Recipient is required.";

	if (
		token === "ckBTC" ||
		token === "ICP" ||
		token === "ckETH" ||
		token === "USDM" ||
		token === "MMK"
	) {
		if (trimmed.length < 10 || !trimmed.includes("-")) {
			return `Enter a valid IC principal for ${token}.`;
		}
	} else if (token === "ckBTC-native") {
		if (!/^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/.test(trimmed)) {
			return "Enter a valid Bitcoin address (bc1... or 1... or 3...).";
		}
	}
	return undefined;
}
